module.exports = __webpack_public_path__ + "static/testimonial-6-9bec70ae9b851f31743828db4206bc11.png";